import { instance } from './instance'

/**
 * Service für Session-API-Anfragen
 */
export const sessionService = {
  /**
   * Initialisiert eine neue Session
   * @param {Object} sessionData - Session-Daten (tableId, customerName, etc.)
   * @returns {Promise} Antwort mit Session-ID
   */
  initSession(sessionData) {
    return instance.post('/Sessions', sessionData)
  },

  /**
   * Holt eine Session
   * @param {string} sessionId - Session-ID
   * @returns {Promise} Antwort mit Session-Daten
   */
  getSession(sessionId) {
    return instance.get(`/Sessions/${sessionId}`)
  },

  /**
   * Holt eine Session anhand des zufälligen Pfades
   * @param {string} sessionPath - Zufälliger Session-Pfad
   * @returns {Promise} Antwort mit Session-Daten
   */
  getSessionByPath(sessionPath) {
    return instance.get(`/Sessions/by-path/${sessionPath}`)
  },

  /**
   * Aktualisiert eine Session
   * @param {string} sessionId - Session-ID
   * @param {Object} sessionData - Aktualisierte Session-Daten
   * @returns {Promise} Antwort mit aktualisierten Session-Daten
   */
  updateSession(sessionId, sessionData) {
    return instance.put(`/Sessions/${sessionId}`, sessionData)
  },

  /**
   * Beendet eine Session
   * @param {string} sessionId - Session-ID
   * @returns {Promise} Antwort mit Status
   */
  endSession(sessionId) {
    return instance.delete(`/Sessions/${sessionId}`)
  },

  /**
   * Holt alle Sessions für einen Tisch
   * @param {number} tableId - Tisch-ID
   * @returns {Promise} Antwort mit Sessions
   */
  getSessionsByTable(tableId) {
    return instance.get(`/Tables/${tableId}/sessions`)
  }
} 